import { getFormulaImageUrl } from "@/utils/nutrition/getFormulaImageUrl";

interface FormulaCardProps {
  title: string;
  description: string;
  image: string;
  backgroundImage: string;
  isSubscribed?: boolean;
}

export const FormulaCard = ({
  title,
  description,
  image,
  backgroundImage,
  isSubscribed,
}: FormulaCardProps) => {
  return (
    <div
      className="flex flex-col items-center text-center p-6 rounded"
      style={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <div className="w-40 h-40 mb-4">
        <img src={getFormulaImageUrl(image)} alt={title} className="w-full h-full object-contain" />
      </div>
      <h3 className="typography-h2 text-primary mb-2">
        {title}
      </h3>
      <p className="typography-body text-secondary">
        {description}
      </p>
      {isSubscribed && (
        <span className="typography-caption2 text-success mt-2">
          Subscribed
        </span>
      )}
    </div>
  );
};